'use strict';

class Filter {
    ui;
    wrap;

    constructor(options) {
        if (options.wrap) {
            this.wrap = options.wrap;
        }

        if (this.wrap) {
            this.ui = {
                expand: $(this.wrap).find('.js-filter-expand')
            };
            this.bindUIActions();
        }
    }

    bindUIActions() {
        window.addEventListener('load', () => this.setExpandState());
    }

    setExpandState() {
        if (window.innerWidth < 850) {
            $(this.ui.expand).removeClass('is-expanded').addClass('is-collapsed');
        }
        $(this.ui.expand).removeClass('is-not-loaded').addClass('is-loaded');
    }
}

export default Filter;
